<template>
    <div class="conditionalJson">
        <p v-if="showTitle"><b>Conditional JSON:</b></p>
        <div class="conditionalJsonButtonContainer">
            <button @click="addJsonLogic('equals')"><i class="fas fa-equals"></i></button>
            <button @click="addJsonLogic('notEquals')"><i class="fas fa-not-equal"></i></button>
            <button @click="addJsonLogic('in')">IN</button>
            <button @click="addJsonLogic('and')">AND</button>
            <button @click="addJsonLogic('or')">OR</button>
        </div>
        <textarea v-model="internalJsonText" @blur="saveChanges" :ref="'conditionalJsonTextArea'"></textarea>
    </div>
</template>

<script>
export default {
    name: 'ConditionalJson',
    props: {
        jsonText: {
            type: String
        },
        object: {
            type: Object
        },
        showTitle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            internalJsonText:''
        }
    },
    mounted() {
        this.internalJsonText = this.jsonText ? this.jsonText : '';
    },
    methods: {
        addJsonLogic: function(operation) {
            const textarea = this.$refs['conditionalJsonTextArea'];
            const index = textarea.selectionStart;
            let addedText;
            switch(operation) {
                case 'equals':
                    addedText = '{"==":[{"var":"VARIABLE_NAME"},"VALUE"]}';
                    break;
                case 'notEquals':
                    addedText = '{"!=":[{"var":"VARIABLE_NAME"},"VALUE"]}';
                    break;
                case 'in':
                    addedText = '{"in":[{"var":"VARIABLE_NAME"},["VALUE1","VALUE2"]]}';
                    break;
                case 'and':
                    addedText = '{"and":[]}';
                    break;
                case 'or':
                    addedText = '{"or":[]}';
                    break;
            }
            this.internalJsonText = `${this.internalJsonText.substring(0,index)}${addedText}${this.internalJsonText.substring(index)}`;
            textarea.focus();
            setTimeout(() => {
                textarea.selectionStart = index + addedText.length;
                textarea.selectionEnd = index + addedText.length;
            });
        },
        saveChanges: function() {
            this.$emit('saveConditionalJsonChanges', this.internalJsonText, this.object);
        }
    }
}
</script>

<style scoped>
    .conditionalJsonButtonContainer button {
        margin: 0 20px 10px 0;
        padding: 5px;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
    }
</style>